<!-- eslint-disable -->
<template>
  <div></div>
</template>
<script>
// eslint-disable
import "@/assets/lib/filerobot-image-editor.min.js";
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const options = this.config;
      options.finishButtonLabel = this.config.finishButtonLabel || "save";

      this.callbacks = {};
      console.log("open");
      const vm = this;
  
      this.callbacks.onError = (error) => {
        vm.$emit("error", error);
      };
    
      this.callbacks.onClose = (status) => {
        vm.$emit("close", status);
      };
     
      this.callbacks.onBeforeComplete = function (element) {
        vm.$emit("beforeComplete", element);
        console.error(element.canvas.toDataURL());
        return false;
      };
     
      this.callbacks.onComplete = (url, file) => {
        this.$emit("complete", url, file);
      };

  
      this.imageEditor = new window.FilerobotImageEditor(
        options,
        this.callbacks
      );
      this.imageEditor.open(this.src);
 
    },
  },
  destroy() {
    if (this.imageEditor) {
      this.imageEditor.unmounted();
    }
  },
};
</script>